export default "__VITE_ASSET__BTxrwJOX__"